import { ITaskResponse } from '../modules/tasks/model/types';
import { FormUtils } from '../shared/components/framework/services/form-builder.service';
import { TaskDataService } from '../shared/services/task-data.service';
import { Observable } from 'rxjs';

export function assignTaskToMe(taskIds: string[], service: TaskDataService): Observable<any> {
  return service.assignTaskToMe(taskIds)
}

export function createCancellationRequests(tasks: Pick<ITaskResponse, 'id'>[]): Array<Pick<ITaskResponse, 'id' | 'action'>> {
  return tasks.map(({ id }) => ({ id, action: 'Cancel' }));
}

export function updateTask(task: ITaskResponse, action: string, service: TaskDataService): Observable<any> {
  console.log('Updating task with action:', task, action);
  task.action = action;
  let formData = FormUtils.mapToFormData(task);
  // mapToFormData skips null values, so explicitly ensure tooltip is always present
  // (server needs it to preserve the value when null/undefined on the grid row)
  if (!formData.has('tooltip')) {
    formData.append('tooltip', task.tooltip || '');
  }
  return service.updateTaskAsFormData(formData);
}